import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const NavArrow = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 16 16" sx={{ height: '16px', width: '16px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M2.6665 8H13.3332M13.3332 8L9.33317 4M13.3332 8L9.33317 12"
        stroke={props.color === 'warning' ? '#939393' : '#14191F'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default NavArrow;
